module.exports = __webpack_public_path__ + "7ce29073adfe04f483d01372b6bb650d.svg";